<!-- Search Field -->
<div class="search">
    <form [formGroup]="searchForm">
        <div class="form-controls">
            <input
                hamInput
                icon="/assets/hamIcons/search-outline.svg"
                formControlName="searchTerm"
                placeholder="{{ 'aumico_reports_fcp_search_placeholder' | i18next }}"
                (cancel)="resetFilter()"
                (focus)="openDropdown()"
                (keydown)="onAnyKey($event)"
            />
        </div>
    </form>
</div>

<!-- Selected Items as Chips -->
<div class="selected-items" *ngIf="selectedItems != null && selectedItems.length !== 0 && !dropdownOpen">
    <span *ngFor="let selectedItem of selectedItems" class="chip">
        {{
            selectedItem.data.title ||
                selectedItem.data.caption ||
                selectedItem.data.accountNumber + ' ' + selectedItem.data.name
        }}
        <button (click)="deselectNode(selectedItem)">✖</button>
    </span>
</div>

<div class="dropdown-panel" *ngIf="dropdownOpen && filteredMappingItemsSelectionTree">
    <div class="tree-list">
        <ng-container *ngFor="let node of filteredMappingItemsSelectionTree.children">
            <mapping-items-tree-node [node]="node" (toggleSelect)="onToggleSelect($event)"></mapping-items-tree-node>
        </ng-container>
    </div>
</div>
